import { FC, JSX, useContext, useMemo } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { UiStatisticsCollapseContext } from "@app/performance/contexts/UiStatisticsCollapseContext";

interface CollapseProps {
  graphs: JSX.Element[];
  onOpen?: () => void;
  title: string;
}

/**
 * A custom "accordion" that removes its children from the DOM when closed. This is done intentionally to prevent excessive network calls from the iframe children.
 * @param props
 */
export const UiStatisticsCollapse: FC<React.PropsWithChildren<CollapseProps>> = (props: CollapseProps) => {
  const { collapseCategory, expandCategory, expandedCategories } = useContext(UiStatisticsCollapseContext);

  const isOpen = useMemo(() => {
    return expandedCategories.includes(props.title);
  }, [expandedCategories]);

  const handleClick = () => {
    if (isOpen) {
      collapseCategory(props.title);
    } else {
      expandCategory(props.title);
      props.onOpen && props.onOpen();
    }
  }

  return (
    <section id={props.title}>
      <QESButton qesType="secondary" className="pt-1 pb-1 ps-2 text-dark" onClick={handleClick} aria-pressed={isOpen} qesTestId={`ui-statistics-collapse__toggle--${props.title}`}>
        <QesIcon iconName={isOpen ? QesIcons.ChevronDown : QesIcons.ChevronRight} description={isOpen ? "Collapse" : "Expand" } /> <span>{props.title}</span>
      </QESButton>
      <div>
        {isOpen && props.graphs}
      </div>
    </section>
  )
}